// extracted by mini-css-extract-plugin
export default {"root":"_xg6_p","iframeHolder":"SMuTIa","iframe":"wuksD5"};